"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var i18next_1 = __importDefault(require("i18next"));
var classnames_1 = __importDefault(require("classnames"));
var facebook_icon_svg_1 = __importDefault(require("@assets/widgets/app/facebook-icon.svg"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        builtByLinkGroup: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        builtByImg: {
            height: '25px',
            userDrag: 'none',
        },
    });
});
var FacebookWidget = function (_a) {
    var className = _a.className;
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classnames_1.default(className, classes.builtByLinkGroup) },
        react_1.default.createElement(core_1.Link, { href: i18next_1.default.t('general.links.facebook'), target: "_blank", style: { height: '100%' } },
            react_1.default.createElement("img", { src: facebook_icon_svg_1.default, className: classes.builtByImg, alt: i18next_1.default.t('general.builtBy') }))));
};
exports.default = FacebookWidget;
